import React from "react";
import { Grid2 } from "@mui/material";
// styles
import styles from "./WelcomeDashboard.module.scss";
import { useSelector } from "react-redux";
import { ReactComponent as NewOrgImage } from "../../Features/Admin/AdminAssets/svg/NewOrganization.svg";
import { ReactComponent as Teammates } from "../../GlobalAssets/svg/Teammates.svg";
import { ReactComponent as Migratesite } from "../../GlobalAssets/svg/Migrateyoursite.svg";
import WelcomePlanCard from "../WelcomePlanCard/WelcomePlanCard";
import Manage from "./ManageComponent/Manage";
import NewRoconCard from "../NewRoconCard/NewRoconCard";
import { useNavigate } from "react-router-dom";

export default function WelcomeDashboard() {
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state.users?.userDetails);
  const selectedOrg = useSelector(
    (state) => state.organizationsInfo?.selectedOrg
  );
  const allPlans = useSelector(
    (state) => state.plansInfo.allPlans?.plans?.licenses
  );
  const orgName = selectedOrg?.orgId ? selectedOrg?.orgId : -1;

  const urlPath = window.location.pathname;
  const segments = urlPath.split("/");
  const Ind = segments[2];

  let domain = window.location.hostname;
  domain =
    domain === "localhost" ? process.env.REACT_APP_METADATA_DOMAIN : domain;

  return (
    <>
      <Grid2 className={styles.WelcomeDashboardContainer}>
        <Grid2>
          <span className={styles.text}>
            Welcome
            {domain === process.env.REACT_APP_FRONTEND_DOMAIN
              ? " to Rocon"
              : ""}
            ,
          </span>{" "}
          <span className={styles.text}>
            {userDetails?.userName ? userDetails?.userName : "_____"}
          </span>
          <Grid2 className={styles.text1}>
            Everything you need to build, manage, and grow your WordPress site
            is here.
          </Grid2>
        </Grid2>
        <Grid2 className={styles.createWebsite}>
          <Grid2 className={styles.flexBox}>
            <Grid2 className={styles.image}>
              <NewOrgImage className={styles.OrgImage} />
            </Grid2>
            <Grid2 className={styles.headerFlexBox}>
              <Grid2>
                <Grid2 className={styles.header}>
                  Effortless Website Launch in Minutes
                  {/* <span className={styles.headerColor}> Create a Website</span> */}
                </Grid2>
                <Grid2 className={styles.subHeader}>
                  Grab <span className={styles.bold}>85% </span>Off Hosting
                  Today!
                </Grid2>
              </Grid2>
              <WelcomePlanCard
                userDetails={userDetails}
                selectedOrg={selectedOrg}
                allPlans={allPlans}
                navigate={navigate}
                orgName={orgName}
                Ind={Ind}
              />
            </Grid2>
          </Grid2>
        </Grid2>
        <Grid2 className={styles.ManageFlexbox}>
          {Ind === "-1" && (
            <Manage
              icon={Teammates}
              header="Organization"
              title="Get your projects up and running faster by inviting your team to collaborate."
              button="Create Organization"
              onClick={() => {
                navigate("/account/create-organization");
              }}
            />
          )}
          {Ind !== "-1" && (
            <Manage
              icon={Teammates}
              header="Collaborate Seamlessly with Your Team"
              title="Easily collaborate with your team during site development — no need to share login credentials!"
              button="Add Team Member"
              onClick={() => {
                navigate(`/account/${orgName}/team-members`);
              }}
            />
          )}
          <Manage
            icon={Migratesite}
            header="Free Site Migration"
            title="Effortlessly migrate your sites to Rocon. Our team handles all the details for you, for free!"
            button="Learn More"
            onClick={() => {
              window.open(
                "https://docs.roconpaas.io/home/migrate-your-site/",
                "_blank"
              );
            }}
          />
        </Grid2>
        {domain === process.env.REACT_APP_FRONTEND_DOMAIN ? (
          <Grid2 className={styles.NewRocon}>
            <Grid2 className={styles.Rocon}>
              What's New at <span className={styles.RoconColor}>ROCON</span>
            </Grid2>
            <Grid2 className={styles.NewRoconCardFlexbox}>
              <NewRoconCard
                icon="https://roconpaas.com/wp-content/uploads/2024/10/Fastest-Hosting-for-WordPress.webp"
                header="If you’ve ever clicked away from a slow-loading website, you understand how frustrating that experience can be"
                onClick={() => {
                  window.open(
                    "https://roconpaas.com/blog/fastest-hosting-for-wordpress/",
                    "_blank"
                  );
                }}
              />
              <NewRoconCard
                icon="https://roconpaas.com/wp-content/uploads/2024/06/Benefits-of-Managed-WordPress-Hosting-3.webp"
                header="Imagine managed WordPress hosting as a personal pit crew for your website. It’s not so much about renting server space but partnering with experts"
                onClick={() => {
                  window.open(
                    "https://roconpaas.com/blog/the-benefits-of-managed-wordpress-hosting-why-its-worth-the-investment/",
                    "_blank"
                  );
                }}
              />
              <NewRoconCard
                icon="https://roconpaas.com/wp-content/uploads/2024/11/Reliable-Managed-WordPress-Hosting.png"
                header="Managed WordPress hosting has become the go to choice for website owners who care about performance, security and support"
                onClick={() => {
                  window.open(
                    "https://roconpaas.com/blog/reliable-managed-wordpress-hosting/",
                    "_blank"
                  );
                }}
              />
            </Grid2>
          </Grid2>
        ) : (
          ""
        )}
      </Grid2>
    </>
  );
}
